export const COUNTRIES = [
  'India', 'United States', 'United Kingdom', 'Canada', 'Australia',
  'UAE', 'Singapore', 'Germany', 'France', 'Japan', 'China', 'Brazil',
  'South Africa', 'New Zealand', 'Malaysia', 'Philippines', 'Bangladesh',
  'Pakistan', 'Sri Lanka', 'Nepal',
];

export const STATES: Record<string, string[]> = {
  'India': [
    'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
    'Delhi', 'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand',
    'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur',
    'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan',
    'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh',
    'Uttarakhand', 'West Bengal',
  ],
  'United States': [
    'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado',
    'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho',
    'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana',
    'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota',
    'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada',
    'New Hampshire', 'New Jersey', 'New Mexico', 'New York',
    'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon',
    'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota',
    'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington',
    'West Virginia', 'Wisconsin', 'Wyoming',
  ],
  'United Kingdom': [
    'England', 'Scotland', 'Wales', 'Northern Ireland',
  ],
  'Canada': [
    'Alberta', 'British Columbia', 'Manitoba', 'New Brunswick',
    'Newfoundland and Labrador', 'Nova Scotia', 'Ontario',
    'Prince Edward Island', 'Quebec', 'Saskatchewan',
  ],
  'Australia': [
    'New South Wales', 'Queensland', 'South Australia', 'Tasmania',
    'Victoria', 'Western Australia', 'ACT', 'Northern Territory',
  ],
  'UAE': [
    'Abu Dhabi', 'Dubai', 'Sharjah', 'Ajman', 'Umm Al Quwain',
    'Ras Al Khaimah', 'Fujairah',
  ],
  'Germany': [
    'Bavaria', 'Berlin', 'Brandenburg', 'Bremen', 'Hamburg', 'Hesse',
    'Lower Saxony', 'Mecklenburg-Vorpommern', 'North Rhine-Westphalia',
    'Rhineland-Palatinate', 'Saarland', 'Saxony', 'Saxony-Anhalt',
    'Schleswig-Holstein', 'Thuringia',
  ],
};

export function getStates(country: string): string[] {
  return STATES[country] || [];
}

export interface CountryDialCode {
  code: string;   // e.g. "+91"
  flag: string;   // emoji flag
  country: string;
}

export const COUNTRY_CODES: CountryDialCode[] = [
  // South Asia (default region first)
  { flag: '🇮🇳', code: '+91',  country: 'India' },
  { flag: '🇵🇰', code: '+92',  country: 'Pakistan' },
  { flag: '🇧🇩', code: '+880', country: 'Bangladesh' },
  { flag: '🇱🇰', code: '+94',  country: 'Sri Lanka' },
  { flag: '🇳🇵', code: '+977', country: 'Nepal' },
  { flag: '🇲🇻', code: '+960', country: 'Maldives' },
  { flag: '🇧🇹', code: '+975', country: 'Bhutan' },
  // East & Southeast Asia
  { flag: '🇨🇳', code: '+86',  country: 'China' },
  { flag: '🇯🇵', code: '+81',  country: 'Japan' },
  { flag: '🇰🇷', code: '+82',  country: 'South Korea' },
  { flag: '🇰🇵', code: '+850', country: 'North Korea' },
  { flag: '🇸🇬', code: '+65',  country: 'Singapore' },
  { flag: '🇲🇾', code: '+60',  country: 'Malaysia' },
  { flag: '🇹🇭', code: '+66',  country: 'Thailand' },
  { flag: '🇻🇳', code: '+84',  country: 'Vietnam' },
  { flag: '🇵🇭', code: '+63',  country: 'Philippines' },
  { flag: '🇮🇩', code: '+62',  country: 'Indonesia' },
  { flag: '🇲🇲', code: '+95',  country: 'Myanmar' },
  { flag: '🇰🇭', code: '+855', country: 'Cambodia' },
  { flag: '🇱🇦', code: '+856', country: 'Laos' },
  { flag: '🇧🇳', code: '+673', country: 'Brunei' },
  { flag: '🇹🇱', code: '+670', country: 'Timor-Leste' },
  { flag: '🇹🇼', code: '+886', country: 'Taiwan' },
  { flag: '🇭🇰', code: '+852', country: 'Hong Kong' },
  { flag: '🇲🇴', code: '+853', country: 'Macau' },
  { flag: '🇲🇳', code: '+976', country: 'Mongolia' },
  // Middle East
  { flag: '🇦🇪', code: '+971', country: 'UAE' },
  { flag: '🇸🇦', code: '+966', country: 'Saudi Arabia' },
  { flag: '🇶🇦', code: '+974', country: 'Qatar' },
  { flag: '🇰🇼', code: '+965', country: 'Kuwait' },
  { flag: '🇧🇭', code: '+973', country: 'Bahrain' },
  { flag: '🇴🇲', code: '+968', country: 'Oman' },
  { flag: '🇾🇪', code: '+967', country: 'Yemen' },
  { flag: '🇮🇷', code: '+98',  country: 'Iran' },
  { flag: '🇮🇶', code: '+964', country: 'Iraq' },
  { flag: '🇸🇾', code: '+963', country: 'Syria' },
  { flag: '🇯🇴', code: '+962', country: 'Jordan' },
  { flag: '🇱🇧', code: '+961', country: 'Lebanon' },
  { flag: '🇮🇱', code: '+972', country: 'Israel' },
  { flag: '🇵🇸', code: '+970', country: 'Palestine' },
  { flag: '🇹🇷', code: '+90',  country: 'Turkey' },
  { flag: '🇦🇲', code: '+374', country: 'Armenia' },
  { flag: '🇦🇿', code: '+994', country: 'Azerbaijan' },
  { flag: '🇬🇪', code: '+995', country: 'Georgia' },
  // Europe
  { flag: '🇬🇧', code: '+44',  country: 'United Kingdom' },
  { flag: '🇩🇪', code: '+49',  country: 'Germany' },
  { flag: '🇫🇷', code: '+33',  country: 'France' },
  { flag: '🇮🇹', code: '+39',  country: 'Italy' },
  { flag: '🇪🇸', code: '+34',  country: 'Spain' },
  { flag: '🇵🇹', code: '+351', country: 'Portugal' },
  { flag: '🇳🇱', code: '+31',  country: 'Netherlands' },
  { flag: '🇧🇪', code: '+32',  country: 'Belgium' },
  { flag: '🇨🇭', code: '+41',  country: 'Switzerland' },
  { flag: '🇦🇹', code: '+43',  country: 'Austria' },
  { flag: '🇸🇪', code: '+46',  country: 'Sweden' },
  { flag: '🇳🇴', code: '+47',  country: 'Norway' },
  { flag: '🇩🇰', code: '+45',  country: 'Denmark' },
  { flag: '🇫🇮', code: '+358', country: 'Finland' },
  { flag: '🇮🇸', code: '+354', country: 'Iceland' },
  { flag: '🇮🇪', code: '+353', country: 'Ireland' },
  { flag: '🇵🇱', code: '+48',  country: 'Poland' },
  { flag: '🇨🇿', code: '+420', country: 'Czech Republic' },
  { flag: '🇸🇰', code: '+421', country: 'Slovakia' },
  { flag: '🇭🇺', code: '+36',  country: 'Hungary' },
  { flag: '🇷🇴', code: '+40',  country: 'Romania' },
  { flag: '🇧🇬', code: '+359', country: 'Bulgaria' },
  { flag: '🇭🇷', code: '+385', country: 'Croatia' },
  { flag: '🇷🇸', code: '+381', country: 'Serbia' },
  { flag: '🇧🇦', code: '+387', country: 'Bosnia' },
  { flag: '🇸🇮', code: '+386', country: 'Slovenia' },
  { flag: '🇲🇰', code: '+389', country: 'North Macedonia' },
  { flag: '🇦🇱', code: '+355', country: 'Albania' },
  { flag: '🇲🇪', code: '+382', country: 'Montenegro' },
  { flag: '🇽🇰', code: '+383', country: 'Kosovo' },
  { flag: '🇬🇷', code: '+30',  country: 'Greece' },
  { flag: '🇨🇾', code: '+357', country: 'Cyprus' },
  { flag: '🇲🇹', code: '+356', country: 'Malta' },
  { flag: '🇷🇺', code: '+7',   country: 'Russia' },
  { flag: '🇺🇦', code: '+380', country: 'Ukraine' },
  { flag: '🇧🇾', code: '+375', country: 'Belarus' },
  { flag: '🇲🇩', code: '+373', country: 'Moldova' },
  { flag: '🇱🇻', code: '+371', country: 'Latvia' },
  { flag: '🇱🇹', code: '+370', country: 'Lithuania' },
  { flag: '🇪🇪', code: '+372', country: 'Estonia' },
  { flag: '🇱🇺', code: '+352', country: 'Luxembourg' },
  { flag: '🇲🇨', code: '+377', country: 'Monaco' },
  { flag: '🇱🇮', code: '+423', country: 'Liechtenstein' },
  { flag: '🇸🇲', code: '+378', country: 'San Marino' },
  { flag: '🇻🇦', code: '+379', country: 'Vatican' },
  // Americas
  { flag: '🇺🇸', code: '+1',   country: 'United States' },
  { flag: '🇨🇦', code: '+1',   country: 'Canada' },
  { flag: '🇲🇽', code: '+52',  country: 'Mexico' },
  { flag: '🇧🇷', code: '+55',  country: 'Brazil' },
  { flag: '🇦🇷', code: '+54',  country: 'Argentina' },
  { flag: '🇨🇱', code: '+56',  country: 'Chile' },
  { flag: '🇨🇴', code: '+57',  country: 'Colombia' },
  { flag: '🇵🇪', code: '+51',  country: 'Peru' },
  { flag: '🇻🇪', code: '+58',  country: 'Venezuela' },
  { flag: '🇪🇨', code: '+593', country: 'Ecuador' },
  { flag: '🇧🇴', code: '+591', country: 'Bolivia' },
  { flag: '🇵🇾', code: '+595', country: 'Paraguay' },
  { flag: '🇺🇾', code: '+598', country: 'Uruguay' },
  { flag: '🇬🇾', code: '+592', country: 'Guyana' },
  { flag: '🇸🇷', code: '+597', country: 'Suriname' },
  { flag: '🇨🇺', code: '+53',  country: 'Cuba' },
  { flag: '🇯🇲', code: '+1876', country: 'Jamaica' },
  { flag: '🇭🇹', code: '+509', country: 'Haiti' },
  { flag: '🇩🇴', code: '+1809', country: 'Dominican Republic' },
  { flag: '🇬🇹', code: '+502', country: 'Guatemala' },
  { flag: '🇭🇳', code: '+504', country: 'Honduras' },
  { flag: '🇸🇻', code: '+503', country: 'El Salvador' },
  { flag: '🇳🇮', code: '+505', country: 'Nicaragua' },
  { flag: '🇨🇷', code: '+506', country: 'Costa Rica' },
  { flag: '🇵🇦', code: '+507', country: 'Panama' },
  { flag: '🇹🇹', code: '+1868', country: 'Trinidad & Tobago' },
  { flag: '🇧🇧', code: '+1246', country: 'Barbados' },
  // Africa
  { flag: '🇳🇬', code: '+234', country: 'Nigeria' },
  { flag: '🇿🇦', code: '+27',  country: 'South Africa' },
  { flag: '🇰🇪', code: '+254', country: 'Kenya' },
  { flag: '🇪🇹', code: '+251', country: 'Ethiopia' },
  { flag: '🇬🇭', code: '+233', country: 'Ghana' },
  { flag: '🇹🇿', code: '+255', country: 'Tanzania' },
  { flag: '🇺🇬', code: '+256', country: 'Uganda' },
  { flag: '🇷🇼', code: '+250', country: 'Rwanda' },
  { flag: '🇿🇲', code: '+260', country: 'Zambia' },
  { flag: '🇿🇼', code: '+263', country: 'Zimbabwe' },
  { flag: '🇸🇳', code: '+221', country: 'Senegal' },
  { flag: '🇨🇮', code: '+225', country: "Côte d'Ivoire" },
  { flag: '🇨🇲', code: '+237', country: 'Cameroon' },
  { flag: '🇲🇦', code: '+212', country: 'Morocco' },
  { flag: '🇩🇿', code: '+213', country: 'Algeria' },
  { flag: '🇹🇳', code: '+216', country: 'Tunisia' },
  { flag: '🇱🇾', code: '+218', country: 'Libya' },
  { flag: '🇪🇬', code: '+20',  country: 'Egypt' },
  { flag: '🇸🇩', code: '+249', country: 'Sudan' },
  { flag: '🇸🇸', code: '+211', country: 'South Sudan' },
  { flag: '🇦🇴', code: '+244', country: 'Angola' },
  { flag: '🇲🇿', code: '+258', country: 'Mozambique' },
  { flag: '🇲🇬', code: '+261', country: 'Madagascar' },
  { flag: '🇳🇦', code: '+264', country: 'Namibia' },
  { flag: '🇧🇼', code: '+267', country: 'Botswana' },
  { flag: '🇲🇺', code: '+230', country: 'Mauritius' },
  // Oceania
  { flag: '🇦🇺', code: '+61',  country: 'Australia' },
  { flag: '🇳🇿', code: '+64',  country: 'New Zealand' },
  { flag: '🇫🇯', code: '+679', country: 'Fiji' },
  { flag: '🇵🇬', code: '+675', country: 'Papua New Guinea' },
  { flag: '🇼🇸', code: '+685', country: 'Samoa' },
  { flag: '🇹🇴', code: '+676', country: 'Tonga' },
];

// ────────────────────────────────────────────────────────────────────────────
// Country helpers — derived from COUNTRY_CODES so we have one source of
// truth. Previously a handful of pages each hit restcountries.com on mount,
// which (a) added a 3rd-party SPOF and (b) wasted ~200ms per page load.
// ────────────────────────────────────────────────────────────────────────────

/**
 * Alphabetically sorted list of country names. Use this anywhere a country
 * <select> is rendered — LeadFormModal, UserFormDrawer, ProfilePage,
 * SettingsPage, LeadAssignPage all read this directly instead of calling
 * restcountries.com.
 */
export const COUNTRY_NAMES: string[] = COUNTRY_CODES
  .map((c) => c.country)
  .sort((a, b) => a.localeCompare(b));

/**
 * Reverse a flag emoji to its ISO-3166-1 alpha-2 code (e.g. 🇮🇳 → "IN").
 * Flag emojis are two Regional Indicator codepoints; subtracting the
 * 🇦 base and adding 'A' gives the letter. RegisterPage uses this to match
 * against IP-geo detection (which returns cca2).
 */
export function flagToCca2(flag: string): string {
  const cps = Array.from(flag).map((ch) => ch.codePointAt(0) ?? 0);
  if (cps.length < 2) return '';
  return cps
    .slice(0, 2)
    .map((cp) => String.fromCharCode(cp - 0x1f1e6 + 65))
    .join('');
}

/**
 * Country list for RegisterPage's flag-prefixed dropdown. Pre-computed so
 * the select renders synchronously on first paint.
 */
export interface CountryWithCca2 {
  value: string;     // country name, used as form value
  label: string;     // "🇮🇳 India"
  cca2: string;      // "IN" — matches the IP-geo lookup field
}

export const COUNTRIES_WITH_FLAGS: CountryWithCca2[] = COUNTRY_CODES
  .map((c) => ({
    value: c.country,
    label: `${c.flag} ${c.country}`,
    cca2: flagToCca2(c.flag),
  }))
  .sort((a, b) => a.value.localeCompare(b.value));
